import { startOfDay as t } from "./startOfDay.js";
function n(a, r) {
  const e = t(a), f = t(r);
  return +e == +f;
}
export {
  n as default,
  n as isSameDay
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/isSameDay.js
// module id = 1392
// module chunks = 67